  <div class="search-results"
        [infiniteScrollContainer]="'.community-feed-list'"
  [fromRoot]="true" infinite-scroll (scrolled)="onScrollDown($event)">
  <div class="tab-content">
    <div id="kt_project_users_card_pane" class="tab-pane fade show active">
      <div class="g-xl-9" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()" [scrollWindow]="false">

        <div class="row flex-column justify-content-center align-items-center w-100 my-15p"
          *ngIf="!feedList || !feedList.length">
          <i class="bi bi-exclamation-circle" style="font-size: 120px; width: fit-content;"></i>
          <span class="fs-4 text-center my-4 fw-bold">No posts found.</span>
        </div>


        <ng-container *ngIf="feedList && feedList.length">

          <div class="position-relative" *ngFor="let post of feedList; let i = index">
            <app-community-feed-single-post (onDelete)="onDelete(i)" [post]="post"></app-community-feed-single-post>
            <!-- z-index 0, after the card: still drawn over the card, but under the
                 sticky page header (#kt_toolbar is z-index 1) when the post scrolls up. -->
            <span *ngIf="unseenUuids?.includes(post.uuid)" class="position-absolute rounded-circle"
              style="top: 12px; left: -6px; width: 10px; height: 10px; background: #e0803c; border: 1.5px solid #a4521a; box-shadow: 0 0 0 2px #fff; z-index: 0;"
              role="img" aria-label="New since your last visit" title="New since your last visit"></span>
            <div *ngIf="newBoundaryUuid && post.uuid === newBoundaryUuid" class="d-flex align-items-center gap-3 my-4" role="separator" [attr.aria-label]="'New since your last visit' + (newSince ? ', ' + (newSince | date: 'd MMM') : '') + ', above'">
              <span class="flex-grow-1" style="height: 1px; background: #e0803c;"></span>
              <span class="fs-7 fw-bold" style="color: #a4521a;">&uarr; New since your last visit<ng-container *ngIf="newSince">, {{ newSince | date: 'EEE d MMM' }}</ng-container></span>
              <span class="flex-grow-1" style="height: 1px; background: #e0803c;"></span>
            </div>
          </div>
        </ng-container>

      </div>
    </div>

  </div>
</div>
